import { Flip, gsap } from "@/composeables/gsap"

// Adapted from https://codepen.io/GreenSock/pen/vYMzKZx
// (GSAP "Scrubbed Bento Gallery" – ScrollTrigger + Flip)
function createSectionAnimation(section) {
    const gallery = section.querySelector(".section-bento-stage__grid")
    const items = gallery?.querySelectorAll(".section-bento-stage__tile")
    const content = section.querySelector(".section-bento-stage__content")

    if (!gallery || !items?.length) return

    const mm = gsap.matchMedia()

    mm.add("(prefers-reduced-motion: no-preference)", () => {
        let flipCtx

        const create = () => {
            flipCtx?.revert()
            // Kill any leftover Flip animations on these items. Without this,
            // Flip.getState() can re-apply geometry cached from the previous
            // viewport (Flip stores element state on a hidden property), so
            // the "from" layout ends up using the old viewport dimensions.
            Flip.killFlipsOf(items)
            items.forEach(el => el.removeAttribute("style"))

            flipCtx = gsap.context(() => {
                // Capture the final layout, then flip back so the grid renders
                // in its bento state. Flip.to() then animates from current
                // (bento) to the captured (final) layout under scrub control.
                gallery.classList.add("section-bento-stage__grid--final")
                const flipState = Flip.getState(items)
                gallery.classList.remove("section-bento-stage__grid--final")

                const flip = Flip.to(flipState, {
                    simple: true,
                    ease: "expoScale(1, 5)",
                })

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: gallery,
                        start: "center center",
                        end: "+=100%",
                        scrub: true,
                        pin: section,
                    },
                })
                tl.add(flip)

                if (content) {
                    tl.fromTo(content,
                        { autoAlpha: 0, y: 40 },
                        { autoAlpha: 1, y: 0, duration: 0.3, ease: "power2.out" },
                        '-=0.20',
                    )
                }

                return () => items.forEach(el => el.removeAttribute("style"))
            }, section)
        }

        create()

        let prevWidth = window.innerWidth
        let resizeTimeout
        const onResize = () => {
            // Height-only resizes (mobile URL bar) don't change Flip geometry,
            // so skip the expensive teardown.
            if (window.innerWidth === prevWidth) return
            prevWidth = window.innerWidth

            clearTimeout(resizeTimeout)
            resizeTimeout = setTimeout(create, 150)
        }
        window.addEventListener("resize", onResize)

        return () => {
            clearTimeout(resizeTimeout)
            window.removeEventListener("resize", onResize)
            flipCtx?.revert()
        }
    })
}

export const init = () => {
    const sections = gsap.utils.toArray(".section-bento-stage")
    sections.forEach(createSectionAnimation)
}

export default init
